import { Link, NavLink } from 'react-router-dom'
import { useState } from 'react';
import { Menu, X, Search } from "lucide-react";



export default function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return (
    <div>
      {/* Navbar */}
      <header className="fixed top-0 left-0 z-50 w-full bg-white p-4 text-black shadow-md md:h-20">
        <div className="container mx-auto flex justify-between items-center ">
          <Link to="/" aria-label="Vasundhara Seeds home"><img src='/logo_hindi.jpeg' alt="Vasundhara Seeds" className="w-40 cursor-pointer" /></Link>
          {/* Mobile Menu Button */}
          <button
            type="button"
            aria-label={isMenuOpen ? "Close navigation menu" : "Open navigation menu"}
            aria-expanded={isMenuOpen}
            className="text-gray-700 focus:outline-none md:hidden"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>

          {/* Search Bar (Hidden on Mobile, Visible on Large Screens) */}
          <div className="hidden items-center rounded-full bg-gray-100 px-3 py-1 shadow-inner lg:flex">
            <Search className="text-gray-500" />
            <input
              type="text"
              placeholder="Search products..."
              className="bg-transparent outline-none text-gray-700 w-48"
            />
            <button className="bg-green-500 text-white px-3 py-1 rounded-full hover:bg-green-600 transition-all">
              Search
            </button>
          </div>

          {/* Nav Bar */}
          <nav
            className={`absolute md:relative top-full left-0 md:top-0 w-full md:w-auto bg-white md:bg-transparent shadow-md md:shadow-none transition-all ease-in-out duration-300 z-50 ${isMenuOpen ? "block" : "hidden"
              } md:flex md:items-center`}
          >
            <ul className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-6 p-5 md:p-0">
              {[["Home", "/"], ["About Us", "/about-us"], ["Infrastructure", "/infrastructure"], ["Products", "/products"], ["Contact", "/contact"]].map(([label, path]) => (
                <li key={path} className="border-b pb-2 md:border-0 md:pb-0">
                  <NavLink
                    to={path}
                    end={path === "/"}
                    className={({ isActive }) => `text-sm font-semibold tracking-wide transition-all hover:text-green-700 ${isActive ? 'text-green-800' : 'text-black'}`}
                    onClick={() => setIsMenuOpen(false)}
                  >
                    {label}
                  </NavLink>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </header>
      <div className="w-full h-[2px] bg-yellow-900 fixed top-20 left-0 z-50"></div>



      {/* WhatsApp button */}
      <a
        href="https://wa.me/9425332127"
        className="fixed bottom-20 right-4 bg-green-500 text-white p-4 rounded-full shadow-lg hover:scale-110 transition transform z-50 animate-bounce"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" alt="WhatsApp" className="w-10 h-10" />
      </a>

    </div>

  )
}
